import { isApiError } from '@counsel-project/client-utils'
import toast from 'react-hot-toast'
import log from './logging'

const handleError = (err: unknown, prefix?: string) => {
  if (isApiError(err)) {
    log.warn(prefix ? `${prefix}: ${err.msg}` : err.msg)
    toast.error(err.msg || 'An unexpected error has occurred')
  } else {
    log.error(prefix ? `${prefix}: ${err}` : err)
    toast.error('An unexpected error has occurred')
  }
}

export default handleError
